import { NdfDemandsCalculationsFiltered } from '@interfaces/a-organizar/ndfDemandsCalculationsFiltered';
import { createAction, props } from '@ngrx/store';

export const setSelectedDemand = createAction(
  '[Demand] Set Selected Demand',
  props<{ demand: NdfDemandsCalculationsFiltered | null }>()
);
